import { updateCustomerLanguage } from '@/api/query/customer';
import { isAuthenticated } from '@/common/contexts/GuestAuthContext';
import { readLanguageFromHost } from '@/common/utils/language';

export const syncCustomerLanguageWithHost = async () => {
	const language = readLanguageFromHost();

	if (!language || !isAuthenticated()) {
		return;
	}

	await updateCustomerLanguage({ language });
};
